var store = require('../store')

module.exports = {
  props: ['params'],
  data: function() {
    return {
      topics: []
    }
  },
  watch: {
    'params.tab': 'update'
  },
  compiled: function() {
    this.update()
  },
  computed: {
    selectTopicId: function() {
      return this.params.topicId
    }
  },
  methods: {
    update: function() {
      var tab = this.params.tab
      if(!tab) return

      this.topics = []
      this.fetchTopics(tab)
    },
    fetchTopics: function(tab) {
      var page = this.params.page

      store.fetchTopics(tab, page)
        .then(function(result) {
          // console.log(result)
          // this.topics = result.data
          this.topics = this.topics.concat(result.data)
          this.params.page ++
        }.bind(this))
    },
    select: function(topicId) {
      this.params.topicId = topicId
    },
    loadMore: function() {
      this.fetchTopics(this.params.tab)
    }
  }
}


/** WEBPACK FOOTER **
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/topic-list.vue
 **/